module.exports = __webpack_public_path__ + "static/media/19_tn.725e4295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/19_tn.jpg
// module id = 157
// module chunks = 0